import(/* webpackMode: "eager" */ "/app/src/app/[festival-slug]/[locale]/(auth)/account/accreditation/page.tsx");
